import React from 'react';
import { useAppContext } from '../../contexts/AppContext';
import { APP_MODE } from '../../constants/AppModes';
import LeafletMapAdapter from './LeafletMapAdapter';
import NaverMapAdapter from './NaverMapAdapter';

/**
 * 🗺️ UnifiedMapView - 공통 지도 인터페이스
 * 
 * GPS 위치 기반으로 한국(Naver) / 글로벌(Leaflet) 자동 선택
 * 국내는 무조건 네이버 지도 사용 (폴백 없음)
 */
const UnifiedMapView = ({
    center,              // { lat, lng } - 지도 중심점
    spots = [],          // 스팟 배열
    selectedSpotId,      // 선택된 스팟 ID (하이라이트용)
    onSpotClick,         // 스팟 클릭 핸들러
    myPos,               // 내 위치 { lat, lng }
    isExpanded = false,  // 지도 확장 상태
    mapTarget,           // [lat, lng, timestamp] - 외부에서 이동 요청
    useKakao = true,     // true: Naver(한국), false: Leaflet(글로벌) - 이름 유지 (호환성)
    onToggleMap,         // 테스트용 토글 콜백 (선택적)
    setOffScreenIndicator, // 🎯 [NEW] 오프스크린 인디케이터 상태 업데이트 함수
    distanceRadius,      // 🎯 [NEW] 거리 반경 (줌 레벨 조정용)
    pointSpots = [],     // 🎯 [NEW] Point Spots
    onPointSpotClick,    // 🎯 [NEW] Handler
    onMapReady,           // 🎯 [NEW] 지도 인스턴스 콜백
    isTreasureHuntMode   // 🎯 [FIX] 보물찾기 모드 여부
}) => {
    // 🎯 [AppMode] 전역 리소스 모드 구독
    const { appMode } = useAppContext();
    const isHeavyTask = appMode === APP_MODE.HEAVY_TASK;

    // 공통 props
    const adapterProps = {
        center,
        spots,
        selectedSpotId,
        onSpotClick,
        myPos,
        isExpanded,
        mapTarget,
        setOffScreenIndicator,
        distanceRadius, // 🎯 [NEW] Pass to adapters
        pointSpots,     // 🎯 [NEW]
        onPointSpotClick, // 🎯 [NEW]
        onMapReady,      // 🎯 [NEW] Pass to adapters
        isTreasureHuntMode // 🎯 [FIX] Pass to adapters
    };

    // 🎯 [AppMode] 리소스 독점 작업 시 지도 렌더링 숨김 (GPU 충돌 방지)
    // display: none을 사용하여 DOM은 유지하되 렌더링 파이프라인에서 제외
    const containerStyle = {
        width: '100%',
        height: '100%',
        position: 'relative',
        display: isHeavyTask ? 'none' : 'block'
    };

    return (
        <div style={containerStyle}>
            {/* 테스트용 토글 버튼 (onToggleMap이 있을 때만 표시) */}


            {/* 지도 어댑터 선택 - 렌더링 트리 유지 */}
            {useKakao ? (
                <NaverMapAdapter {...adapterProps} />
            ) : (
                <LeafletMapAdapter {...adapterProps} />
            )}
        </div>
    );
};

export default UnifiedMapView;
